import { render } from "./mat-fab.vue?vue&type=template&id=70e7a1c0&scoped=true&lang=true"
import script from "./mat-fab.vue?vue&type=script&lang=js"
export * from "./mat-fab.vue?vue&type=script&lang=js"

import "./mat-fab.vue?vue&type=style&index=0&id=70e7a1c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e7a1c0"]])

export default __exports__